export default __webpack_public_path__ + "static/media/facebook.edd32f4e.svg";